// extracted by mini-css-extract-plugin
var _1 = "group-jKSFD";
var _2 = "left-_3Nli";
var _3 = "quantity-EEweL";
var _4 = "right-h0RJg";
export { _1 as "group", _2 as "left", _3 as "quantity", _4 as "right" }
